module.exports = __webpack_public_path__ + "img/12.47934338.png";